import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router'

const NavBarContainer = styled.div`
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #dacfb4;
`

const PageTabItem = styled(NavLink)`
    display: flex;
    height: 100%;
    padding: 0 40px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`

const TabItemText = styled.div`
    color: #121b21;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
`

const NavBar: React.FC = () => {
    const { t } = useTranslation('', { keyPrefix: 'pagenavigator' })

    return (
        <NavBarContainer>
            <PageTabItem
                to="/"
                style={({ isActive }) => ({
                    backgroundColor: isActive ? '#f6f6f6' : '#dacfb4',
                    '&:hover, &:focus': {
                        background: '#e9e9e9',
                    },
                })}
            >
                <TabItemText>{t('home')}</TabItemText>
            </PageTabItem>
            <PageTabItem
                to="/hkjcpriorityprogramme"
                style={({ isActive }) => ({
                    backgroundColor: isActive ? '#f6f6f6' : '#dacfb4',
                    '&:hover, &:focus': {
                        background: '#e9e9e9',
                    },
                })}
            >
                <TabItemText>{t('hkjcpriorityprogramme')}</TabItemText>
            </PageTabItem>
            <PageTabItem
                to="/earnwins"
                style={({ isActive }) => ({
                    backgroundColor: isActive ? '#f6f6f6' : '#dacfb4',
                    '&:hover, &:focus': {
                        background: '#e9e9e9',
                    },
                })}
            >
                <TabItemText>{t('earnwins')}</TabItemText>
            </PageTabItem>
            <PageTabItem
                to="/spendwins"
                style={({ isActive }) => ({
                    backgroundColor: isActive ? '#f6f6f6' : '#dacfb4',
                    '&:hover, &:focus': {
                        background: '#e9e9e9',
                    },
                })}
            >
                <TabItemText>{t('spendwins')}</TabItemText>
            </PageTabItem>
            <PageTabItem
                to="/helpcentre"
                style={({ isActive }) => ({
                    backgroundColor: isActive ? '#f6f6f6' : '#dacfb4',
                    '&:hover, &:focus': {
                        background: '#e9e9e9',
                    },
                })}
            >
                <TabItemText>{t('helpcentre')}</TabItemText>
            </PageTabItem>
        </NavBarContainer>
    )
}

export default NavBar
